//测试接口
const domain ='https://woshimiapptest.mvoicer.com/woshimi_app'
const smkdomain='http://woshimimalltest.mvoicer.com/woshimi_app'

//生产接口
// const smkdomain='https://woshimimall.mvoicer.com/woshimi_app' 
// const domain="https://woshimiapp.mvoicer.com/woshimi_app"



const interfaces={
    getCode:domain+"/system/verification/code",
    getWebSmsCode:domain+"/user/getWebSmsCode",
    //企鹅 蛋壳合作页
    getUserWebRegister:domain+"/user/userWebRegister",
//520 活动接口
    //活动商品列表
    getActivityLoveGoodsList:domain+"/activity/getActivityLoveGoodsList",
    //用户店铺商品列表
    getUserActivityLoveShop:domain+"/activity/getUserActivityLoveShop",
    //用户上架商品
    saveUserActivityLoveShopGoods:domain+"/activity/saveUserActivityLoveShopGoods",
    //用户修改店名
    saveUserActivityLoveShopName:domain+"/activity/saveUserActivityLoveShopName",
    //活动商品购买
    getUserActivityLoveGoodsInfo:domain+"/activity/getUserActivityLoveGoodsInfo",
    //购买商品
    userBuyActivityLoveGoods:domain+"/activity/userBuyActivityLoveGoods",
    //购买商品用户列表
    getUserShopConsumerList:domain+"/activity/getUserShopConsumerList",
    //登录接口
    login:domain+"/user/userWebLogin",
    //分享二维码接口
    erweima:domain+"/activity/getActivityLoveQRCodeShare",
    //周年活动接口部分
    //获取用户时光轴
     getUserTimeAxis:domain+"/anniversary/getUserTimeAxis",
     //获取回归礼包
     getUserReturnPrize:domain+'/anniversary/getUserReturnPrize',
     //获取分享礼包
     getUserSharePrize:domain+"/anniversary/getUserSharePrize",
    //支付接口
      pay:smkdomain+'/activity/web/front/pay',
      order:smkdomain+'/activity/web/verify/pay',  
      //礼物排行榜
      getGiftWeekRank: smkdomain +'/activity/getGiftWeekRank', 

}


module.exports=interfaces






// WEBPACK FOOTER //
// ./src/utils/interfaces.js